import { atom } from 'jotai'

/**
 * 配送依頼インポートModalの表示状態
 */
export const isOpenShipmentOrderImportModalAtom = atom<boolean>(false)

isOpenShipmentOrderImportModalAtom.debugLabel =
  'isOpenShipmentOrderImportModalAtom'
